export default {
  brokerDealerOpportunities: { featured: [], other: [] },
};
